import { StackedCellText } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';
import type { MeetPerson } from '@/types/meetPerson.types';

interface MeetPeopleCellProps {
  meetPeople: MeetPerson[];
}

function MeetPersonMobile({ mobile }: Pick<MeetPerson, 'mobile'>) {
  return <span className="whitespace-nowrap tabular-nums">{mobile}</span>;
}

export function MeetPeopleCell({ meetPeople }: MeetPeopleCellProps) {
  if (meetPeople.length === 0) return <EmptyValue />;

  return (
    <span className="flex flex-col gap-1.5">
      {meetPeople.map((person) => (
        <StackedCellText
          key={person.mobile}
          primary={person.name ?? <MeetPersonMobile mobile={person.mobile} />}
          secondary={person.name ? <MeetPersonMobile mobile={person.mobile} /> : null}
        />
      ))}
    </span>
  );
}
